import React, { ChangeEvent, useContext, useEffect, useState } from 'react'

import { Icon } from '../../components/Icon'
import { policyHeader } from '../../data/index'
import Menu from '../../components/UI/UIMenu'
import Modal from '../../components/UI/UIModal'
import UITextArea from '../../components/UI/UITextArea'
import UITextInput from '../../components/UI/UITextInput'
import UISubHeaderComponent from '../../components/UI/UISubHeaderComponent'
// import Pagination from '../../components/UI/Pagination'
import '../../App.css'

import {
  createPolicy,
  deletePolicy,
  updatePolicy,
  updatePolicyStatus,
} from '../../api/admin/policies'
import {
  ErrorResponse,
  UploadResponse,
  getSinglePolicy,
} from '../../utils/types'
import { toast } from 'react-toastify'
import { useQuery } from 'react-query'
import {
  // capitalizeFirstLetter,
  formatDate,
  formatDateToUsDate,
  getErrorMessage,
} from '../../utils/utils'
import UIDatePickerv from '../../components/UI/UIDatePickerv'
import Loading from '../../components/UI/Loading'
import {
  // calculatePageCount,
  checkValidation,
  downloadPDF,
  initialData,
  lastStr,
  statusBgColor,
} from './utils'
import { fileUpload } from '../../api/apiService'
import { getPolicyData, getPolicyDataById } from './apiCalls'
import PdfViewer from '../../components/UI/PdfViewer'
import { useToggledSwitches } from '../../context/ToggledSwitchesContext'
import { SidebarContext } from '../../context/SidebarContext'

interface policiesHeaderInterface {
  Title: number
  Status: string
  Owner: string
  'Date Created': string
  'Approval Date': string
  'Approved by': string
  'Next Review Date': string
}
export interface FormData {
  title: string
  description: string
  policyDocument: string
  otherInformation: {
    relatedPolicyDocuments: string
    owner: string
    version: string
    createdDate: string
    createdApproval: string
    approvedBy: string
    approvedDate: string
    commenceDate: string
    lastReviewDate?: string
    nextReviewDate: string
  }
}

const Policy = () => {
  const { toggledSwitches } = useToggledSwitches()
  function getStoredIds(key: string): string[] {
    // Retrieve the JSON string from local storage
    const storedIdsString = localStorage.getItem(key)

    // Parse the JSON string and return it as an array
    if (storedIdsString) {
      try {
        const storedIds = JSON.parse(storedIdsString)

        // Ensure that the parsed data is an array of strings
        if (
          Array.isArray(storedIds) &&
          storedIds.every((id) => typeof id === 'string')
        ) {
          return storedIds
        } else {
          return []
        }
      } catch (error) {
        return []
      }
    }

    // Return an empty array if there's no data in local storage
    return []
  }

  const schoolIds = getStoredIds('SchoolIds')
  const { viewBool, setViewBool } = useContext(SidebarContext)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isOpenPdfViewer, setIsOpenPdfViewer] = useState<boolean>(false)
  const [pdfUrl, setPdfUrl] = useState('')
  const [isOpenDelete, setIsOpenDelete] = useState<boolean>(false)
  // const [showOtherPart, setShowOtherPart] = useState<boolean>(false)
  const [isView, setIsView] = useState(viewBool)
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [id, setId] = useState<string | null>(null)
  const [sId, setSId] = useState<string | null>(null)
  // const [currentPage, setCurrentPage] = useState<number>(1)
  // const totalPages: number = 10 // Set the total number of pages here
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [formData, setFormData] = useState<FormData | getSinglePolicy>(
    initialData
  )

  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('title')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const policyById = useQuery(
    ['policyById', id, sId],
    () => getPolicyDataById(id, sId),
    {
      enabled: !!sId || !!id,
    }
  )

  const policies = useQuery('policy', () =>
    getPolicyData(
      // currentPage,
      sortBy,
      sortOrderValue,
      toggledSwitches.length > 0 ? toggledSwitches : schoolIds
    )
  )
  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(Number(policies?.data?.count) || 100).fill(false)
  )

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    policies.refetch() // Refetch incidents when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  const handleDragOver = (event: { preventDefault: () => void }) => {
    event.preventDefault()
  }

  const handleDrop = async (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    const file = event.dataTransfer.files[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('policyDocument', response?.url)
        setSelectedFile(file)
      } catch (error) {
        setSelectedFile(null)
        handleChange('policyDocument', '')
        toast.error(getErrorMessage(error, 'Failed to upload file'), {
          position: 'top-right',
        })
      }
    }
  }

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('policyDocument', response?.url)
        setSelectedFile(file)
      } catch (error) {
        setSelectedFile(null)
        handleChange('policyDocument', '')
        toast.error(getErrorMessage(error, 'Failed to upload file'), {
          position: 'top-right',
        })
      }
    }
  }

  const handleRemoveFile = () => {
    setSelectedFile(null)
    handleChange('policyDocument', '')
  }
  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)

  //   // You can add additional logic here, like fetching data for the new page
  // }

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleOpenModal = () => {
    setIsOpen(true)
    setFormData(initialData)
    setIsEdit(false)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }

  const handleCloseDeleteModal = () => {
    setIsOpenDelete(false)
  }

  const handleChange = (fieldName: string, value: string): void => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const handleOtherInfoChange = (fieldName: string, value: string): void => {
    setFormData((prevState) => ({
      ...prevState,
      otherInformation: {
        ...prevState.otherInformation,
        [fieldName]: value,
      },
    }))
  }
  function removeNullEntries<T>(obj: T): Partial<T> {
    const newObj: Partial<T> = {}

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key as keyof T]

        if (
          value !== null &&
          typeof value === 'object' &&
          !Array.isArray(value)
        ) {
          // Recursively remove null entries for nested objects
          newObj[key as keyof T] = removeNullEntries(value) as T[keyof T]
        } else if (value !== null) {
          newObj[key as keyof T] = value
        }
      }
    }

    return newObj
  }
  const createNewPolicy = async (): Promise<void> => {
    try {
      setIsLoading(true)
      const response = (await createPolicy(formData)) as {
        status?: string
        data: getSinglePolicy
      }
      if (response?.status == 'successful') {
        policies.refetch()
        setFormData(initialData)
        handleCloseModal()
        setSelectedFile(null)
        toast.success('Policy Created.', {
          position: 'top-right',
        })
        setIsLoading(false)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
        setIsLoading(false)
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const [isUpdating, setIsUpdating] = useState(false)

  // The dialog stays open until the save succeeds, so a failed save shows why and can be retried
  const editPolicy = async (): Promise<void> => {
    setIsUpdating(true)
    try {
      const response = (await updatePolicy(
        removeNullEntries(formData) as FormData,
        id
      )) as {
        status?: string
        data: getSinglePolicy
      }
      if (response?.status !== 'successful') throw new Error()
      handleCloseModal()
      setIsView(false)
      setIsEdit(false)
      policies.refetch()
      toast.success('Policy Updated.', {
        position: 'top-right',
      })
    } catch (error) {
      toast.error(
        getErrorMessage(
          error,
          'The policy could not be updated. Please try again.'
        ),
        { position: 'top-right' }
      )
    } finally {
      setIsUpdating(false)
    }
  }
  const editPolicyStatus = async (status: string): Promise<void> => {
    const response = (await updatePolicyStatus(
      {
        status: status,
      },
      id
    )) as {
      status?: string
      data: getSinglePolicy
    }
    if (response?.status == 'successful') {
      policies.refetch()
      policyById.refetch()

      toast.success('Policy Status Updated.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }
  const removePolicy = async (): Promise<void> => {
    try {
      const response = (await deletePolicy({ id: id })) as {
        status?: string
        data: getSinglePolicy
      }
      if (response?.status == 'successful') {
        policies.refetch()
        setIsEdit(false)
        setIsView(false)
        setIsOpenDelete(!isOpenDelete)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  // useEffect(() => {
  //   policies.refetch()
  // }, [currentPage])

  useEffect(() => {
    policies.refetch()
  }, [toggledSwitches])

  useEffect(() => {
    setIsView(viewBool)
  }, [viewBool])
  return (
    <div
      className={
        'flex flex-col gap-20 w-full  bg-white  h-full rounded-3xl p-8 '
      }
    >
      {!isView && (
        <div className="flex flex-col gap-6 w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>
                Policy Manager
              </p>
              {/* <p
                className={
                  'text-[14px] font-normal text-text1 leading-[24px] mt-2'
                }
              >
                Here you can view and manage your policy documentation. Upload
                and amend, change their review dates or set their status.
              </p> */}
            </div>

            <div className={'flex flex-row gap-[15px]'}>
              <div
                onClick={handleOpenModal}
                className="gap-[10px]  bg-bluishGreen items-center min-w-[95px] text-white px-5 py-3 flex rounded-[72px] cursor-pointer"
              >
                <p className={'font-semibold text-sm leading-6 text-white'}>
                  Create Policy
                </p>
                <Icon
                  name={'IconPlus'}
                  strokeWidth={1.1}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
              </div>
            </div>
          </div>
          {/* content container */}
          <div className="relative h-full overflow-y-auto">
            <div className=" max-h-full h-full overflow-y-auto">
              {policies.isLoading && (
                <div className="flex-col  w-[100%] p-[10px]">
                  <Loading size="large" />
                </div>
              )}
              {!policies.isLoading && (
                <table className="min-w-full table-auto divide-y-4 divide-white">
                  <thead className="sticky top-0 z-10 mb-4">
                    <tr className="bg-gray2 rounded-lg h-10 mb-18">
                      {policyHeader?.map((item: string, index: number) => {
                        return (
                          <th
                            key={index}
                            className={`px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${index === policyHeader.length - 1 ? 'border-none' : 'border-r border-white'}`}
                          >
                            <div className="flex items-center">
                              <p className="text-text1 font-semibold text-sm flex-1">
                                {item}
                              </p>
                              <div
                                className="cursor-pointer"
                                onClick={() => {
                                  let sortBy = ''
                                  switch (
                                  item as keyof policiesHeaderInterface
                                  ) {
                                    case 'Title':
                                      sortBy = 'title'
                                      break
                                    case 'Status':
                                      sortBy = 'status'
                                      break
                                    case 'Owner':
                                      sortBy = 'owner'
                                      break
                                    case 'Date Created':
                                      sortBy = 'createdAt'
                                      break
                                    case 'Approval Date':
                                      sortBy = 'updatedAt'
                                      break
                                    case 'Approved by':
                                      sortBy = 'approvedBy'
                                      break
                                    case 'Next Review Date':
                                      sortBy = 'nextReviewDate'
                                      break
                                    default:
                                      break
                                  }
                                  handleSort(sortBy)
                                }}
                              >
                                <Icon
                                  name={'IconChevronDown'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1}
                                  stroke={'#67A5B9'}
                                />
                              </div>
                            </div>
                          </th>
                        )
                      })}
                      <th className="w-[56px] rounded-r-lg"></th>{' '}
                    </tr>
                  </thead>
                  <tbody>
                    {policies?.data?.data?.map((item, index) => (
                      <>
                        <tr className="bg-gray1">
                          {/* Example row */}
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            <div className="flex flex-row items-center w-full">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                                {item.title}
                              </p>
                              <div
                                onClick={() => {
                                  if (!item.policyDocumentUrl) return

                                  if ((item.policyDocumentUrl as unknown as string) == 'IN PROGRESS') {
                                    return toast.warning("Scanning the file, please check again in a few seconds.", {
                                      position: 'top-right',
                                    })
                                  }
                                  if ((item.policyDocumentUrl as unknown as string) == 'NoSuchKey') {
                                    return toast.warning("File is removed", {
                                      position: 'top-right',
                                    })
                                  }
                                  downloadPDF(item.policyDocumentUrl, 'data.pdf')
                                }}
                                className="cursor-pointer"
                              >
                                <Icon
                                  name={'IconDownloadCloud'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1.2}
                                  stroke={'#67A5B9'}
                                />
                              </div>
                            </div>
                          </td>
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            <div
                              className={`rounded-[40px] justify-center flex px-3 py-2 bg-${statusBgColor(item.status)}`}
                            >
                              <p className="text-xs text-text2 font-medium">
                                {item.status == 'publish'
                                  ? 'Published'
                                  : 'Unpublished'}
                              </p>
                            </div>
                          </td>
                          <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                            <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                              {item.owner}
                            </p>
                          </td>
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                              {formatDate(item.createdDate)}
                            </p>
                          </td>
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                              {formatDate(item.approvedDate)}
                            </p>
                          </td>
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            <p className="text-sm text-text1 leading-6 font-semibold">
                              {item.approvedBy}
                            </p>
                          </td>
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border-b border-white">
                            <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                              {formatDate(item.nextReviewDate)}
                            </p>
                          </td>

                          <td className="px-4 items-center justify-center flex relative  h-[48px] py-2 border-b border-white">
                            <Menu
                              isOpen={isOpenMenu[index]}
                              items={[
                                {
                                  label: 'View',
                                  onClick: () => {
                                    setIsView(true)
                                    setViewBool(true)
                                    setSId(item.schoolId)
                                    setId(item.id)
                                    policyById.refetch()
                                    handleToggleMenu(index)
                                  },
                                  icon: 'IconEye',
                                  iconColor: '',
                                },
                                {
                                  label: 'Edit',
                                  onClick: () => {
                                    setId(item.id)
                                    setIsEdit(true)
                                    setSId(item.schoolId)
                                    setFormData({
                                      title: item.title,
                                      description: item.description,
                                      policyDocument: item.policyDocument,
                                      otherInformation: {
                                        relatedPolicyDocuments:
                                          item.relatedPolicyDocuments,
                                        owner: item.owner,
                                        version: item.version,
                                        createdDate: item.createdDate,
                                        createdApproval: item.createdApproval,
                                        approvedBy: item.approvedBy,
                                        approvedDate: item.approvedDate,
                                        commenceDate: item.commenceDate,
                                        lastReviewDate: item.lastReviewDate,
                                        nextReviewDate: item.nextReviewDate,
                                      },
                                    })

                                    setIsOpen(true)
                                    handleToggleMenu(index)
                                  },
                                  icon: 'IconEdit',
                                  iconColor: '',
                                },
                                {
                                  label:
                                    item.status == 'publish'
                                      ? 'Unpublish'
                                      : 'Publish',
                                  onClick: () =>
                                    editPolicyStatus(
                                      item.status == 'publish'
                                        ? 'unpublish'
                                        : 'publish'
                                    ),
                                  icon: 'IconFileMinus',
                                  iconColor: '',
                                },
                                {
                                  label: 'Remove',
                                  onClick: () => {
                                    setIsOpenDelete(true)
                                    setId(item.id)
                                  },
                                  icon: 'IconTrash',
                                  iconColor: '#FF6666',
                                  textColor: 'text-textError',
                                },
                              ]}
                              type={'table'}
                              setIsOpenMenu={setIsOpenMenu}
                              isOpenMenus={isOpenMenu}
                            >
                              <div
                                onClick={() => {
                                  handleToggleMenu(index)
                                  setId(item.id)
                                }}
                              >
                                <Icon
                                  name={'IconDotsVertical'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1.5}
                                  stroke={'#02698C'}
                                />
                              </div>
                            </Menu>
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          {/* <div className="absolute bottom-[20px]">
            <Pagination
              currentPage={currentPage}
              totalPages={calculatePageCount(
                Number(policies?.data?.count) || 0
              )}
              onPageChange={handlePageChange}
            />
          </div> */}
        </div>
      )}
      {isView && (
        <div
          className=""
          style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}
        >
          <UISubHeaderComponent
            publishButtonTitle={
              policyById?.data?.status == 'publish' ? 'Unpublish' : 'Publish'
            }
            mainPage="Policy Manager"
            subPage={policyById?.data?.title}
            copy=" Here you can view and manage your policy documentation. Upload
                and amend, change their review dates or set their status."
            onCreate={() => {
              handleOpenModal()
              setIsEdit(false)
            }}
            onPublish={() =>
              editPolicyStatus(
                policyById?.data?.status == 'publish' ? 'unpublish' : 'publish'
              )
            }
            onEdit={() => {
              setIsOpen(true)
              setIsEdit(true)
              if (policyById?.data) {
                setFormData(policyById.data as FormData)
              }
            }}
            onDelete={() => {
              setIsOpenDelete(true)
            }}
            isViewMode={true}
            onBack={() => {
              setIsView(false)
              setSId('')
            }}
          />
          {/* content container */}
          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Title
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {policyById?.data?.title}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {policyById?.data?.description}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    File
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div
                      onClick={() => {
                        const url = policyById?.data?.policyDocumentUrl
                        if (url && (url as unknown as string) == 'IN PROGRESS') {
                          return toast.warning("Scanning the file, please check again in a few seconds.", {
                            position: 'top-right',
                          })
                        }
                        if (url && (url as unknown as string) == 'NoSuchKey') {
                          return toast.warning("File is removed", {
                            position: 'top-right',
                          })
                        }

                        setPdfUrl(url as string)
                        setIsOpenPdfViewer(true)

                      }}
                      className="p-4 w-[268px] h-[48px] flex gap-2 items-center bg-white rounded-lg"
                    >
                      <Icon
                        name="IconFile"
                        width={16}
                        height={16}
                        strokeWidth={2}
                        stroke={'#02698C'}
                      />
                      <p className="text-sm font-semibold text-bluishGreen leading-6 flex-1">
                        {lastStr(policyById?.data?.policyDocument)}{' '}
                        <span className="text-xs font-medium leading-5 text-text3">
                          1.7 MB
                        </span>
                      </p>
                      <Icon
                        name="IconDownloadCloud"
                        width={16}
                        height={16}
                        strokeWidth={1.5}
                        stroke={'#67A5B9'}
                      />
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4  h-[48px] py-2 border border-white">
                    <div
                      className={`px-4 rounded-[72px] w-fit py-2 bg-${statusBgColor(policyById?.data?.status || 'active')} flex justify-center items-center`}
                    >
                      <p className="text-text2 font-medium text-xs leading-5">
                        {policyById?.data?.status == 'publish'
                          ? 'Published'
                          : 'Unpublished'}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Created at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {formatDate(
                      policyById?.data?.createdAt?.substring(0, 16) || ''
                    )}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {formatDate(
                      policyById?.data?.updatedAt?.substring(0, 16) || ''
                    )}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>

          <p className={'text-text2 text-[14px] font-semibold leading-6'}>
            Other Information
          </p>

          {/* other information */}
          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Related Policy Document
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {policyById?.data?.otherInformation?.relatedPolicyDocuments}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Owner
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {policyById?.data?.otherInformation?.owner}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Version
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {policyById?.data?.otherInformation?.version}
                  </td>
                </tr>

                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Approval Date
                  </td>
                  <td className="px-4  h-[48px] py-2 border border-white">
                    <div className="flex gap-3 items-center">
                      <p className="font-semibold text-[14px]  leading-6 text-text1">
                        {formatDate(
                          policyById?.data?.otherInformation?.approvedDate?.substring(
                            0,
                            16
                          ) || ''
                        )}
                      </p>
                      {/* <Icon
                        name={'IconAlertTriangle'}
                        stroke={'#02698C'}
                        strokeWidth={1}
                        width={16}
                        height={16}
                      /> */}
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Approved By
                  </td>
                  <td className="px-4 w-[30%] h-[48px] py-2 border border-white">
                    <div className="flex w-[30%] gap-2 items-center bg-gray2 p-3 rounded-xl">
                      <Icon
                        name={'IconUserCircle'}
                        stroke={'#02698C'}
                        strokeWidth={1.2}
                        width={16}
                        height={16}
                      />
                      <p className="text-sm font-semibold leading-6 text-text5">
                        {policyById?.data?.otherInformation?.approvedBy}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Commence Date
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {formatDate(
                      policyById?.data?.otherInformation?.commenceDate?.substring(
                        0,
                        16
                      ) || ''
                    )}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Last Review Date
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {formatDate(
                      policyById?.data?.otherInformation?.lastReviewDate?.substring(
                        0,
                        16
                      ) || ''
                    )}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Next Review Date
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {formatDate(
                      policyById?.data?.otherInformation?.nextReviewDate?.substring(
                        0,
                        16
                      ) || ''
                    )}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Modal isOpen={isOpen} onClose={handleCloseModal}>
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon name={'IconFilePlus'} height={56} width={56} />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              {isEdit ? 'Edit Policy' : 'Create Policy'}
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please enter the policy details and attach your file
            </p>
          </div>
          <div className="w-[100%] flex-col flex gap-4 mt-[10px]">
            <UITextInput
              label={'Policy Title*'}
              onChange={(e) => {
                handleChange('title', e.target.value)
              }}
              onBlur={() => { }}
              placeholder="Please enter your policy title"
              iconName={'none'}
              value={formData?.title}
            />
            <UITextArea
              label={'Description*'}
              onChange={(e) => {
                handleChange('description', e.target.value)
              }}
              onBlur={() => { }}
              placeholder="Please enter your policy description"
              iconName={'none'}
              value={formData?.description}
            />
          </div>
          <div className="flex w-[100%] flex-col gap-1">
            <p className="text-xs font-medium leading-5 text-text5">
              Policy Documents*
            </p>
            {selectedFile ? (
              <div className="w-full p-5 py-3 bg-gray1 rounded-xl flex gap-2">
                <div className="mt-1">
                  <Icon
                    name={'IconFile'}
                    stroke={'#02698C'}
                    strokeWidth={1}
                    height={16}
                    width={16}
                  />
                </div>
                <div className="flex flex-col flex-1 gap-2">
                  <div className="flex gap-2 items-center">
                    <p className="text-sm font-semibold leading-6 text-bluishGreen flex-1 p-0">
                      {selectedFile?.name}
                    </p>
                    <p className="text-xs font-medium leading-5 text-[#01B38B] p-0">
                      Upload Successful
                    </p>
                    <Icon
                      name={'IconCheck'}
                      stroke={'#01B38B'}
                      strokeWidth={1}
                      height={16}
                      width={16}
                    />
                    <div className="cursor-pointer" onClick={handleRemoveFile}>
                      <Icon
                        name={'IconTrash'}
                        stroke={'#02698C'}
                        strokeWidth={1}
                        height={16}
                        width={16}
                      />
                    </div>
                  </div>
                  <div className="rounded-full w-full h-1 bg-[#01B38B]"></div>
                </div>
              </div>
            ) : (
              <div
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                className="w-full p-5 py-3 bg-gray1 rounded-xl flex border-2 border-dashed border-gray3 border-separate border-spacing-3"
              >
                <div className="flex flex-1 items-center gap-2">
                  <Icon
                    name={'IconUploadCloud'}
                    stroke={'#02698C'}
                    strokeWidth={1.5}
                    height={20}
                    width={20}
                  />
                  <p className="font-medium text-xs leading-5 text-text1">
                    Drop your file here or
                  </p>
                </div>
                <label htmlFor="fileInput">
                  <div
                    className="cursor-pointer flex items-center gap-2 bg-bluishGreen p-4 py-3 rounded-full"
                  >
                    <Icon
                      name={'IconUploadCloud'}
                      stroke={'#FFFFFF'}
                      strokeWidth={1.5}
                      height={20}
                      width={20}
                    />
                    <p className="font-medium text-xs leading-5 text-text8">
                      Choose a file to upload
                    </p>
                    <input
                      id="fileInput"
                      type="file"
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                      accept={'.pdf, .doc, .docx, .jpg, .jpeg, .png, .svg'}
                    />
                  </div>
                </label>
              </div>
            )}
            <p className="text-xs font-medium leading-5 text-text3">
              Maximum file size: 5 mb
            </p>
          </div>

          {/* other information */}
          {/* <div
            onClick={() => {
              setShowOtherPart(!showOtherPart)
            }}
            className={'w-full flex justify-between p-2 cursor-pointer'}
          >
            <p className="leading-6 font-semibold text-sm text-text2">
              Other Information
            </p>
            <Icon name={'IconArrowDown'} />
          </div> */}

          <div className="w-[100%] flex-col flex gap-4 mt-[10px]">
            <UITextInput
              label={'Related Policy Documents*'}
              onChange={(e) => {
                handleOtherInfoChange('relatedPolicyDocuments', e.target.value)
              }}
              value={formData?.otherInformation?.relatedPolicyDocuments}
              onBlur={() => { }}
              placeholder="Please specify related documents"
              iconName={'none'}
            />
            <UITextInput
              label={'Owner*'}
              onChange={(e) => {
                handleOtherInfoChange('owner', e.target.value)
              }}
              onBlur={() => { }}
              placeholder="Please specify the owner"
              iconName={'none'}
              value={formData?.otherInformation?.owner}
            />
            <UITextInput
              label={'Version*'}
              onChange={(e) => {
                handleOtherInfoChange('version', e.target.value)
              }}
              onBlur={() => { }}
              placeholder="Please specify the document version"
              iconName={'none'}
              value={formData?.otherInformation?.version}
            />
            <div className="w-[100%] flex gap-4">
              <div className="w-full">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Date Created*'}
                  onChange={(e) => {
                    handleOtherInfoChange('createdDate', e.target.value)
                  }}
                  value={formatDateToUsDate(
                    formData?.otherInformation?.createdDate
                  )}
                />
              </div>
              <div className="w-full">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Approval Created*'}
                  onChange={(e) => {
                    handleOtherInfoChange('createdApproval', e.target.value)
                  }}
                  value={formatDateToUsDate(
                    formData?.otherInformation?.createdApproval
                  )}
                />
              </div>
            </div>
            <UITextInput
              label={'Approved By*'}
              onChange={(e) => {
                handleOtherInfoChange('approvedBy', e.target.value)
              }}
              onBlur={() => { }}
              placeholder="Please specify approved by"
              iconName={'none'}
              value={formData?.otherInformation?.approvedBy}
            />
            <div className="w-[100%] flex gap-4">
              <div className="w-full">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Commence Date*'}
                  onChange={(e) => {
                    handleOtherInfoChange('commenceDate', e.target.value)
                  }}
                  value={formatDateToUsDate(
                    formData?.otherInformation?.commenceDate
                  )}
                />
              </div>
              <div className="w-full">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Last Review Date'}
                  onChange={(e) => {
                    handleOtherInfoChange('lastReviewDate', e.target.value)
                  }}
                  value={formatDateToUsDate(
                    formData?.otherInformation?.lastReviewDate || ''
                  )}
                />
              </div>
            </div>

            <div className="w-[100%] flex gap-4">
              <div className="w-full">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Next Review Date*'}
                  onChange={(e) => {
                    handleOtherInfoChange('nextReviewDate', e.target.value)
                  }}
                  value={formatDateToUsDate(
                    formData?.otherInformation?.nextReviewDate
                  )}
                />
              </div>
              <div className="w-full">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Approved Date*'}
                  onChange={(e) => {
                    handleOtherInfoChange('approvedDate', e.target.value)
                  }}
                  value={formatDateToUsDate(
                    formData?.otherInformation?.approvedDate
                  )}
                />
              </div>
            </div>
          </div>

          {isEdit ? (
            <div className="w-[100%] flex-col flex gap-[10px] justify-center items-center mt-3">
              <button
                onClick={editPolicy}
                disabled={isUpdating}
                className=" bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px] disabled:opacity-60 "
              >
                {isUpdating ? 'Updating...' : 'Update'}
              </button>
              <button
                onClick={handleCloseModal}
                className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px]  "
              >
                Cancel
              </button>
            </div>
          ) : (
            <button
              disabled={checkValidation(formData)}
              onClick={() => {
                handleOpenModal()
                createNewPolicy()
              }}
              className=" bg-bluishGreen disabled:bg-gray1  text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px] mt-3"
            >
              {isLoading ? 'Saving...' : 'Save'}
            </button>
          )}
        </div>
      </Modal>

      <Modal isOpen={isOpenDelete} onClose={handleCloseDeleteModal}>
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseDeleteModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Delete Policy
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Are you sure you want to delete this policy?
            </p>
          </div>

          <button
            onClick={() => {
              removePolicy()
            }}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            onClick={handleCloseDeleteModal}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>

      <PdfViewer
        isOpen={isOpenPdfViewer}
        onClose={() => {
          setIsOpenPdfViewer(false)
        }}
        url={pdfUrl}
        title="PDF Viewer"
      />
    </div>
  )
}

export default Policy
